/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export interface CohortInsights {
  /** Overall cohort performance: behind_benchmark|on_track|ahead */
  cohortStatus: string;
  /** Average days behind/ahead of benchmark (negative = ahead) */
  daysBehind?: number;
  /** Cohort trajectory: accelerating|steady|slowing */
  trend: string;
  /** Number of students in analysis */
  sampleSize: number;
}
